import api from "@/api";
import _ from "lodash";
import translate from "@/helpers/translate"
import {parseJwt} from '@/helpers/helpers'
import Vue from 'vue';
import {toBoolean} from "@amcharts/amcharts4/.internal/core/utils/Type";

const accessToken = localStorage.getItem("access_token");
const anonymousToken = localStorage.getItem("anonymous_token");
const refreshToken = localStorage.getItem("refresh_token");
const userGuid = localStorage.getItem("user_guid");
const userInfoStorage = getUserInfoInitial()
const isMultipleSites = JSON.parse(localStorage.getItem('isMultipleSites'))
const originalCredentialsStorage = JSON.parse(localStorage.getItem('originalCredentials'))
const socialList = JSON.parse(localStorage.getItem('socialList'));
const showAdminMenuStorage = localStorage.getItem('showAdminMenuStorage') != 'false'
const defaultUserInfo = {
    role: "user",
    organizations: [],
    sites: []
}

function getUserInfoInitial() {
    try {
        return JSON.parse(localStorage.getItem('userInfoStorage'))
    } catch (e) {
        return null
    }
}

export default {
    namespaced: true,

    state: {
        socialList,
        defaultRoles: [
            {
                text: translate('admin_Admin'),
                value: 'admin'
            },
            {
                text: translate('admin_Owner'),
                value: 'owner'
            },
            {
                text: translate('admin_Client'),
                value: 'client'
            }
        ],
        userInfo: userInfoStorage || defaultUserInfo,
        userGuid: userGuid,
        guid: null,
        accessToken: accessToken,
        refreshToken: refreshToken,
        anonymousToken: anonymousToken,
        isMultipleSites: isMultipleSites || false,
        hasPlace: false,
        originalCredentials: originalCredentialsStorage || null,
        showAdminMenu: showAdminMenuStorage,
    },

    getters: {
        getShowAdminMenu(state) {
            return state.showAdminMenu
        },
        isAuthorized(state) {
            return state.accessToken != null
        },

        isUserAdmin(state) {
            return state.userInfo.role === 'admin'
        },
        isUserDriver(state) {
            return state.userInfo.driver_site != null;
        },
        hasEditPermission(state) {
            return state.userInfo.sites.length == 0 || state.userInfo.sites[0].permissions.edit
        },

        isUserOwner(state) {
            return state.userInfo.role === 'owner'
        },

        isUserOrgManager(state) {
            return state.userInfo.organizations.length > 0
        },
        getUserOrgIds(state) {
            return state.userInfo.org_ids || []
        },
        isUserAirLeadManager(state) {
            for (let i = 0; i < state.userInfo.sites.length; i++) {
                if(state.userInfo.sites[i].airlead_enabled) return true
            }
            return false
        },
        isAirLeadEnabled(state) {
            return state.userInfo.organization && state.userInfo.organization.airlead_enabled
        },
        isServiceLogManager(state) {
            for (let i = 0; i < state.userInfo.sites.length; i++) {
                if(state.userInfo.sites[i].has_service_logs) return true
            }
            return false
        },
        hasServiceLogs(state) {
            return (state.userInfo.organization && state.userInfo.organization.has_service_logs)
                    || (state.userInfo.organizations && state.userInfo.organizations.length > 0 && state.userInfo.organizations[0].has_service_logs)
        },

        isUserSiteManager(state) {
            return state.userInfo.sites.length > 0
        },

        isUserClient(state) {
            return state.userInfo.role === 'client'
        },

        //
        hasOwnOrganization(state) {
            return !_.isEmpty(state.userInfo.organization)
        },

        hasOwnPlace(state) {
            return state.userInfo.organization && !_.isEmpty(state.userInfo.organization.place)
        },

        hasOrgManagerPlace(state, getters) {
            if (getters.isUserOrgManager) {
                return !_.isEmpty(state.userInfo.organizations[0].place)
            }
            return false
        },

        getCurrentUserFullName(state) {
            return `${state.userInfo.first_name} ${state.userInfo.last_name}`
        },

        getOwnPlace(state) {
            if (state.userInfo.organization && state.userInfo.organization.place) {
                return state.userInfo.organization.place
            } else {
                return null
            }
        },

        //
        ownPlaces(state, getters) {
            if (getters.hasOwnPlace) {
                return state.userInfo.organization.all_places
            }
            return []
        },

        orgManagerPlaces(state, getters) {
            if (getters.hasOrgManagerPlace) {
                return state.userInfo.organizations[0].all_places
            }
            return []
        },

        siteManagerPlaces(state, getters) {
            if (getters.isUserSiteManager) {
                return state.userInfo.sites
            }
            return []
        },


        getUserInfo(state) {
            return state.userInfo
        },

        getOrgUid(state, getters, rootState) {
            if (getters.isUserOwner) {
                return state.userInfo.organization.guid
            } else if (getters.isUserOrgManager) {
                return state.userInfo.organizations[0].guid
            } else if (getters.isUserSiteManager) {
                rootState.owner.analyticTabIndex = 1;
                return state.userInfo.sites[0].organization
            } else {
                return null
            }
        },

        getOriginalCredentials(state) {
            return state.originalCredentials
        },

        isCroLinked(state) {
            return state.userInfo.integrations && state.userInfo.integrations.cro && state.userInfo.integrations.cro.active
        },

        isHubspotLinked(state) {
            return state.userInfo.integrations && state.userInfo.integrations.hubspot && state.userInfo.integrations.hubspot.active
        },
    },

    mutations: {
        setAnonymousToken(state, {token, guid}) {
            state.anonymousToken = token;
            state.guid = guid;
            localStorage.setItem("guid", guid);
            localStorage.setItem("anonymous_token", token);
        },

        resetAnonymousToken(state) {
            state.anonymousToken = null;
            state.guid = null;
            localStorage.removeItem("anonymous_token");
            localStorage.removeItem("guid");
        },

        setAccessToken(state, {accessToken, refreshToken}) {
            state.accessToken = accessToken
            state.refreshToken = refreshToken
            localStorage.setItem("access_token", accessToken)
            localStorage.setItem("refresh_token", refreshToken)
            let jwtData = parseJwt(accessToken)
            localStorage.setItem("ssid", jwtData.ssid)
        },

        setUser(state, user) {
            state.userGuid = user;
            localStorage.setItem("user_guid", user);
        },

        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
            localStorage.setItem('userInfoStorage', JSON.stringify(userInfo))
            if (userInfo.organization || userInfo.organizations.length) {
                state.isMultipleSites = userInfo.organization ? userInfo.organization.multiple : userInfo.organizations[0].multiple
                localStorage.setItem('isMultipleSites', state.isMultipleSites)
            } else {
                state.isMultipleSites = false
            }
            let lang = userInfo.setups.lang_code;
            if (lang && lang !== 'null' && (lang == 'ru' || lang == 'en' || lang == 'uk' || lang == 'de')) {
                (new Vue()).$ml.change(lang)
                state.currentLanguage = lang
                localStorage.setItem('lang', lang)
            }
        },
        toggleAdminMenu(state) {
            state.showAdminMenu = !state.showAdminMenu;
            localStorage.setItem('showAdminMenuStorage', state.showAdminMenu)
        },

        isMultipleSitesAction(state) {
            state.isMultipleSites = !state.isMultipleSites
        },

        removeKeys(state) {
            console.log('remover started')
            state.accessToken = null
            state.refreshToken = null
            state.userGuid = null
            state.userInfo = defaultUserInfo
            localStorage.removeItem('access_token');
            localStorage.removeItem('ssid');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('user_guid');
            localStorage.removeItem('userInfoStorage');
            localStorage.removeItem('makeOwnerBool');
            localStorage.removeItem('isMultipleSites');
            localStorage.removeItem('unlinked_rate');
            localStorage.removeItem('unlinked_rate_question');
            localStorage.removeItem('unlinked_rate_question_location');
            console.log('remover success')
        },

        replaceUserCredentials(state, {user}) {
            console.log(user)
            const originalCredentials = {
                accessToken: state.accessToken,
                refreshToken: state.refreshToken,
                userGuid: state.userGuid,
                name: state.userInfo.first_name + ' ' + state.userInfo.last_name,
                userInfo: state.userInfo,
            }
            state.originalCredentials = originalCredentials
            localStorage.setItem('originalCredentials', JSON.stringify(originalCredentials));

            state.accessToken = user.access_token
            state.refreshToken = user.refresh_token
            state.userGuid = user.user_guid
            localStorage.setItem('access_token', user.access_token);
            localStorage.setItem('refresh_token', user.refresh_token);
            localStorage.setItem('user_guid', user.user_guid);
            let jwtData = parseJwt(user.access_token)
            localStorage.setItem('ssid', jwtData.ssid)
        },

        returnDataToOriginalAccount(state) {
            console.log(`test123 start returnDataToOriginalAccount ${(new Date().getTime())}`)
            let originalCredentials = JSON.parse(localStorage.getItem('originalCredentials'))
            state.accessToken = originalCredentials.accessToken
            state.userGuid = originalCredentials.userGuid
            localStorage.setItem('user_guid', state.userGuid);
            state.refreshToken = originalCredentials.refreshToken
            localStorage.setItem('access_token', originalCredentials.accessToken);
            localStorage.setItem('refresh_token', originalCredentials.refreshToken);
            localStorage.setItem('userInfoStorage', originalCredentials.userInfo);
            state.originalCredentials = null
            let jwtData = parseJwt(originalCredentials.accessToken)
            localStorage.setItem('ssid', jwtData.ssid)
            localStorage.removeItem('originalCredentials')
            console.log(`test123 end returnDataToOriginalAccount ${(new Date().getTime())}`)
        },

        setSocialList(state, {networks}) {
            state.socialList = networks
            localStorage.setItem('socialList', JSON.stringify(networks));
        }

    },
    actions: {

        async signInAsUser(context, {guid}) {
            const url = `/admin/users/${guid}/sign-in`;

            const response = await api.request("post", url);
            context.commit("replaceUserCredentials", {
                user: response.data
            });
            await context.dispatch('fetchUserInfo')
            return response.data
        },

        async returnToOriginalAccount(context) {
            context.commit("returnDataToOriginalAccount")
            await context.dispatch('timeout')
            await context.dispatch('fetchUserInfo')
            await context.dispatch('timeout')
            return
        },

        async timeout(context) {
            return new Promise(resolve => {
                console.debug('wait')
                window.setTimeout(resolve, 200)
            })
        },

        async fetchSocialList(context) {
            const url = "/api/networks";
            const response = await api.request("get", url);
            if (response.data.success) {
                context.commit("setSocialList", {
                    networks: response.data.networks
                });
            }
            return response.data
        },

        async signUpFaceBook(context, {token, questionsUids, startQText}) {
            const url = "/auth/facebook";
            const data = {facebook_token: token, start_tpl_uids: questionsUids, start_tpl_text: startQText};
            return await api.request("post", url, data);
        },

        async signUpGoogle(context, {token, questionsUids, startQText}) {
            const url = "/auth/google";
            const data = {google_token: token, start_tpl_uids: questionsUids, start_tpl_text: startQText};
            return await api.request("post", url, data);
        },

        async signUpGoogleNew(context, {code, redirectUri, questionsUids, startQText}) {
            const url = "/auth/google-new";
            const data = {code: code, redirect_uri: redirectUri, start_tpl_uids: questionsUids, start_tpl_text: startQText};
            return await api.request("post", url, data);
        },

        async logIn(context, body) {
            const url = "/auth/airvote/sign-in";

            return await api.request("post", url, body)
        },
        async pinLogIn(context, body) {
            const url = "/auth/airvote/sign-in/pin";
            return await api.request("post", url, body)
        },
        async setPin(context, {userGuid, pin}) {
            const url = "/auth/airvote/set-pin";
            let body = {
                user_guid: userGuid,
                pin: pin,
            }
            return await api.request("post", url, body)
        },
        async setUserName(context, {userGuid, username}) {
            const url = `/users/${userGuid}/username`;
            let body = {
                username: username,
            }
            return await api.request("put", url, body)
        },
        async resetPassword (context, body) {
            const url = "/auth/reset"
            return await api.request("post", url, body)
        },
        async resetCancelCode (context, body) {
            const url = "/auth/reset/cancel-code"
            return await api.request("post", url, body)
        },
        async resetConfirmCode(context, body) {
            const url = "/auth/reset/confirm-code"
            return await api.request("post", url, body)
        },
        async saveNewPassword(context, body) {
            const url = "/auth/reset/change-password"
            return await api.request("post", url, body)
        },
        async registration(context, body) {
            const url = '/auth/airvote/sign-up';

            return await api.request("post", url, body)
        },

        async fetchUserInfo(context) {
            console.log(`test123 start fetchUserInfo ${(new Date().getTime())}`)
            const url = `/users/${context.state.userGuid}`;
            const response = await api.request("get", url);
            console.log(`test123 end fetchUserInfo ${(new Date().getTime())}`)
            context.commit("setUserInfo", response.data);
            return response.data;
        },

        async saveRole(context, user) {
            const url = `/admin/users/${user.guid}/role`
            const response = await api.request("put", url, {
                role: user.role
            });
            return response
        },
        async fetchNewPassword(context, body) {
            const url = `/users/${context.state.userGuid}/password`;
            return await api.request("put", url, body)
        },

        async resendEmail(context) {
            const url = `/auth/airvote/confirm-email`;
            return await api.request("post", url)
        },

        async updateProfile(context, {body, type}) {
            console.log(context.state)
            const user_uid = context.state.userInfo.guid;
            let url = `/users/${user_uid}`
            if (type == 'info') {
                 url = `/users/${user_uid}/info`;
            } else if (type == 'setups') {
                url = `/users/${user_uid}/setups`;
            }
            try {
                const response = await api.request('post', url, body);
                context.commit("setUserInfo", response.data.profile);
                return response.data
            } catch (error) {
                throw error;
            }
        },
        async updateProfileTimezone(context, {timezone}) {
            console.log(context.state)
            const user_uid = context.state.userInfo.guid;
            let url = `/users/${user_uid}/timezone`;
            let body = {
                timezone: timezone
            }
            try {
                const response = await api.request('post', url, body);
                context.commit("setUserInfo", response.data.profile);
                return response.data
            } catch (error) {
                throw error;
            }
        },
        async updateShifts(context, {body}) {
            console.log(context.state)
            const user_uid = context.state.userInfo.guid;
            let url = `/users/${user_uid}/shifts`;
            try {
                const response = await api.request('post', url, body);
                context.commit("setUserInfo", response.data.profile);
                return response.data
            } catch (error) {
                throw error;
            }
        },
        async fetchUnsubscribeUserInfo(context, {user_uid, token}) {
            const url = `/users/${user_uid}/unsubscribe/profile?token=${token}`
            const response = await api.request("get", url);
            return response
        },
        async updateUnsubscribeProfile(context, data) {
            let url = `/users/${data.user_uid}/unsubscribe/setups?token=${data.token}`
            try {
                const response = await api.request('post', url, data.body);
                return response.data
            } catch (error) {
                throw error;
            }
        },

        async authCro(context, {user_uid, code}) {
            const url = `/auth/cro?state=${user_uid}&code=${code}`
            const response = await api.request("post", url);
            return response
        },

        async unlinkCro(context) {
            const url = `/auth/cro`
            const response = await api.request("delete", url);
            return response
        },

        async authHubspot(context, {user_uid, code, redirect_uri}) {
            const url = `/auth/hubspot?state=${encodeURIComponent(user_uid)}&code=${encodeURIComponent(code)}&redirect_uri=${encodeURIComponent(redirect_uri)}`
            const response = await api.request("post", url);
            return response
        },

        async unlinkHubspot(context) {
            const url = `/auth/hubspot`
            const response = await api.request("delete", url);
            return response
        },

        async logout(context) {
            const url = `/auth/logout`;
            return await api.request("post", url)
        },

        async confirmEmail(context, guid) {
            const url = `/auth/airvote/confirm-email/${guid}`;
            return await api.request("get", url)
        },
        async fetchTelegramHash (context) {
            const user_uid = context.state.userInfo.guid;
            const url = `/users/${user_uid}/tg_hash`
            return await api.request("get", url)

        }

    }
};
